import { Skeleton } from "@/components/ui/skeleton";

const ReviewListSkeleton = () => {
  return (
    <section className="rounded-md border border-brand-cloud bg-white shadow-sm">
      <div className="border-b border-brand-cloud p-5 md:p-6">
        <h2 className="public-section-title">Reviews</h2>
      </div>
      <div className="p-5 md:p-6">
        <div className="divide-y divide-brand-cloud">
          {[1, 2, 3].map((i) => (
            <div key={i} className="py-6 first:pt-0 last:pb-0">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <Skeleton className="h-4 w-32 mb-2" />
                  <Skeleton className="h-4 w-24" />
                </div>
                <Skeleton className="h-5 w-20" />
              </div>
              <Skeleton className="h-4 w-full mb-1" />
              <Skeleton className="h-4 w-3/4" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewListSkeleton;
